import { Button, Center, useToast } from '@chakra-ui/react';
import { useGoogleLogin } from '@react-oauth/google';
import { trpcAdmin } from './lib/trpcAdmin';
import { safeRedirectParam } from '@duke-hq/libauth-client/safeRedirectParam';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthAdmin } from './AuthProviderAdmin';

export function LoginPage() {
  const loginWithGoogleToken = trpcAdmin.auth.googleTokenLogin.useMutation();
  const toast = useToast();
  const { user } = useAuthAdmin();
  const navigate = useNavigate();

  useEffect(() => {
    if (user != null) {
      navigate('/');
    }
  }, [navigate, user]);

  const googleLogin = useGoogleLogin({
    scope: 'openid',
    onSuccess: (tokenResponse) => {
      const accessToken = tokenResponse?.access_token;

      async function handleLoginSuccess(accessToken: string) {
        await loginWithGoogleToken.mutateAsync(accessToken);
        window.location.href = safeRedirectParam(new URLSearchParams(window.location.search));
      }

      if (accessToken) {
        void handleLoginSuccess(accessToken);
      } else {
        toast({
          title: 'Error logging in',
          description: 'No access token received from Google login',
          status: 'error',
          duration: 9000,
          isClosable: true,
        });
      }
    },
    onError: (error) => {
      toast({
        title: 'Error logging in',
        description: error.error_description + ' ' + error.error,
        status: 'error',
        duration: 9000,
        isClosable: true,
      });
    },
    onNonOAuthError: (error) => {
      toast({
        title: 'Error logging in',
        description: error.type,
        status: 'error',
        duration: 2000,
        isClosable: true,
      });
    },
  });

  return (
    <Center h="100vh">
      <Button onClick={() => googleLogin()}>Login with Google</Button>
    </Center>
  );
}
